export default __webpack_public_path__ + "static/media/lb-sb.d2330edf.webp";